const CompletionPopup = ({
    showCompletionPopup,
    handleContinue,
    handleSaveToStorageDraft,
    handleDeleteVideo,
    isSavingDraft,
}) => {
    if (!showCompletionPopup) return null;

    return (
        <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center z-50">
            <h3 className="text-[14px] font-semibold text-white mb-6 text-center">
                Recording Completed
            </h3>
            <div className="flex flex-col space-y-3">
                <button
                    onClick={handleContinue}
                    disabled={isSavingDraft}
                    className="w-[10rem] text-[14px] py-2 px-4 bg-black text-white rounded font-medium hover:bg-gray-900 transition-colors disabled:opacity-50"
                >
                    Continue
                </button>

                <button
                    onClick={handleSaveToStorageDraft}
                    disabled={isSavingDraft}
                    className="w-[10rem] text-[14px] py-2 px-4 bg-gray-100 text-black rounded font-medium hover:bg-gray-200 transition-colors disabled:opacity-50"
                >
                    {isSavingDraft ? "Saving..." : "Save to Drafts"}
                </button>
                <button
                    onClick={handleDeleteVideo}
                    disabled={isSavingDraft}
                    className="w-[10rem] text-[14px] py-2 px-4 bg-gray-100 text-black rounded font-medium hover:bg-gray-200 transition-colors disabled:opacity-50"
                >
                    Delete Video
                </button>
            </div>
        </div>
    );
};

export default CompletionPopup;